import chroma from 'chroma-js';

// eslint-disable-next-line import/prefer-default-export
export function getTextColor(bgHex) {
    const MIN_CONTRAST_RATIO = 3;
    const WHITE = chroma('white');
    const BLACK = chroma('black');
    const contrastWithWhite = chroma.contrast(bgHex, WHITE);
    const contrastWithBlack = chroma.contrast(bgHex, BLACK);
    if (contrastWithWhite >= MIN_CONTRAST_RATIO) {
        return WHITE.hex();
    }
    if (contrastWithBlack >= MIN_CONTRAST_RATIO) {
        return BLACK.hex();
    }
    return BLACK.hex();
}
